import React from 'react';

const ArStep3_1 = ({ ...props }) => {
  return (
    <svg
      {...props}
      width="260"
      height="173"
      viewBox="0 0 260 173"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.708 31.1534C32.6696 26.8015 36.5273 23.7031 40.9842 23.7031H219.359C223.824 23.7031 227.686 26.8127 228.64 31.1749L256.86 160.308C258.154 166.232 253.643 171.836 247.579 171.836H12.4508C6.3779 171.836 1.8643 166.216 3.17458 160.286L31.708 31.1534Z"
        stroke="#ADB5BD"
      />
      <path
        d="M3.5 157.837C11.9 154.158 20.8 154.158 29.2 157.837C38.2971 162.127 46.6971 162.127 54.4 157.837C62.8 153.547 71.2 153.547 79.6 157.837C86.2811 160.371 94.6811 160.371 104.8 157.837C113.2 155.303 121.6 155.303 130 157.837C144.143 163.837 152.543 163.837 155.2 157.837C163.6 151.837 172 151.837 180.4 157.837C186.449 160.478 194.849 160.478 205.6 157.837C214 155.196 222.4 155.196 230.8 157.837C242.793 162.738 251.693 162.738 256.5 157.837"
        stroke="#ADB5BD"
      />
      <path
        d="M6.5 145.837C14.0667 143.18 21.6333 143.523 29.2 146.837C38.2971 151.127 46.6971 151.127 54.4 146.837C62.8 142.547 71.2 142.547 79.6 146.837C86.2811 149.371 94.6811 149.371 104.8 146.837C113.2 144.303 121.6 144.303 130 146.837C144.143 152.837 152.543 152.837 155.2 146.837C163.6 140.837 172 140.837 180.4 146.837C186.449 149.478 194.849 149.478 205.6 146.837C214 144.196 222.4 144.196 230.8 146.837C241.41 151.172 249.208 151.672 254.194 148.337"
        stroke="#ADB5BD"
      />
      <path
        d="M252 138.486C247.032 140.465 239.965 139.582 230.8 135.837C222.4 133.196 214 133.196 205.6 135.837C194.849 138.478 186.449 138.478 180.4 135.837C172 129.837 163.6 129.837 155.2 135.837C152.543 141.837 144.143 141.837 130 135.837C121.6 133.303 113.2 133.303 104.8 135.837C94.6811 138.371 86.2811 138.371 79.6 135.837C71.2 131.547 62.8 131.547 54.4 135.837C46.6971 140.127 38.2971 140.127 29.2 135.837C22.4667 132.888 15.7333 132.302 9 134.081"
        stroke="#ADB5BD"
      />
      <path
        d="M11.5 122.529C17.4 121.483 23.3 122.253 29.2 124.837C38.2971 129.127 46.6971 129.127 54.4 124.837C62.8 120.547 71.2 120.547 79.6 124.837C86.2811 127.371 94.6811 127.371 104.8 124.837C113.2 122.303 121.6 122.303 130 124.837C144.143 130.837 152.543 130.837 155.2 124.837C163.6 118.837 172 118.837 180.4 124.837C186.449 127.478 194.849 127.478 205.6 124.837C214 122.196 222.4 122.196 230.8 124.837C238.67 128.053 244.992 129.158 249.768 128.154"
        stroke="#ADB5BD"
      />
      <path
        d="M247.5 117.464C243.049 117.777 237.482 116.567 230.8 113.837C222.4 111.196 214 111.196 205.6 113.837C194.849 116.478 186.449 116.478 180.4 113.837C172 107.837 163.6 107.837 155.2 113.837C152.543 119.837 144.143 119.837 130 113.837C121.6 111.303 113.2 111.303 104.8 113.837C94.6811 116.371 86.2811 116.371 79.6 113.837C71.2 109.547 62.8 109.547 54.4 113.837C46.6971 118.127 38.2971 118.127 29.2 113.837C24.1333 111.618 19.0667 110.737 14 111.195"
        stroke="#ADB5BD"
      />
      <path
        d="M16.5 100.078C20.7333 100.063 24.9667 100.983 29.2 102.837C38.2971 107.127 46.6971 107.127 54.4 102.837C62.8 98.5468 71.2 98.5468 79.6 102.837C86.2811 105.371 94.6811 105.371 104.8 102.837C113.2 100.303 121.6 100.303 130 102.837C144.143 108.837 152.543 108.837 155.2 102.837C163.6 96.8369 172 96.8369 180.4 102.837C186.449 105.478 194.849 105.478 205.6 102.837C214 100.196 222.4 100.196 230.8 102.837C236.285 105.078 241.018 106.294 245 106.486"
        stroke="#ADB5BD"
      />
      <path
        d="M242.5 95.245C239.079 94.7624 235.179 93.6263 230.8 91.8369C222.4 89.1957 214 89.1957 205.6 91.8369C194.848 94.4781 186.448 94.4781 180.4 91.8369C172 85.8369 163.6 85.8369 155.2 91.8369C152.543 97.8369 144.143 97.8369 130 91.8369C121.6 89.3026 113.2 89.3026 104.8 91.8369C94.6808 94.3713 86.2807 94.3713 79.5996 91.8369C71.1996 87.5468 62.7996 87.5468 54.3996 91.8369C46.6967 96.127 38.2967 96.127 29.1996 91.8369C25.7203 90.3129 22.241 89.4201 18.7617 89.1586"
        stroke="#ADB5BD"
      />
      <path
        d="M21.3242 78.4654C23.9493 78.8965 26.5745 79.687 29.1996 80.8369C38.2967 85.127 46.6967 85.127 54.3996 80.8369C62.7996 76.5468 71.1996 76.5468 79.5996 80.8369C86.2807 83.3713 94.6807 83.3713 104.8 80.8369C113.2 78.3026 121.6 78.3026 130 80.8369C144.143 86.8369 152.543 86.8369 155.2 80.8369C163.6 74.8369 172 74.8369 180.4 80.8369C186.448 83.4781 194.848 83.4781 205.6 80.8369C214 78.1957 222.4 78.1957 230.8 80.8369C234.225 82.2368 237.358 83.2368 240.197 83.8369"
        stroke="#ADB5BD"
      />
      <path
        d="M237.5 72.1712C235.407 71.5851 233.174 70.8071 230.8 69.8369C222.4 67.1957 214 67.1957 205.6 69.8369C194.849 72.4781 186.449 72.4781 180.4 69.8369C172 63.8369 163.6 63.8369 155.2 69.8369C152.543 75.8369 144.143 75.8369 130 69.8369C121.6 67.3026 113.2 67.3026 104.8 69.8369C94.6811 72.3713 86.2811 72.3713 79.6 69.8369C71.2 65.5468 62.8 65.5468 54.4 69.8369C46.6971 74.127 38.2971 74.127 29.2 69.8369C27.3 69.0047 25.4 68.3607 23.5 67.9049"
        stroke="#ADB5BD"
      />
      <path
        d="M26 57.6132C27.0667 57.9618 28.1333 58.3697 29.2 58.8369C38.2971 63.127 46.6971 63.127 54.4 58.8369C62.8 54.5468 71.2 54.5468 79.6 58.8369C86.2811 61.3713 94.6811 61.3713 104.8 58.8369C113.2 56.3026 121.6 56.3026 130 58.8369C144.143 64.8369 152.543 64.8369 155.2 58.8369C163.6 52.8369 172 52.8369 180.4 58.8369C186.449 61.4781 194.849 61.4781 205.6 58.8369C214 56.1957 222.4 56.1957 230.8 58.8369C232.253 59.4305 233.653 59.9523 235 60.4021"
        stroke="#ADB5BD"
      />
      <path
        d="M28 47.3369C37.0971 51.627 46.6973 52.127 54.4002 47.8369C62.8002 43.5468 71.2002 43.5468 79.6002 47.8369C86.2813 50.3713 94.6813 50.3713 104.8 47.8369C113.2 45.3026 121.6 45.3026 130 47.8369C144.144 53.8369 152.544 53.8369 155.2 47.8369C163.6 41.8369 172 41.8369 180.4 47.8369C186.449 50.4781 194.849 50.4781 205.6 47.8369C214 45.1957 224.1 45.1957 232.5 47.8369"
        stroke="#ADB5BD"
      />
      <path
        d="M30 37.3369C39.0971 41.627 46.6971 41.127 54.4 36.8369C62.8 32.5468 71.2 32.5468 79.6 36.8369C86.2811 39.3713 94.6811 39.3713 104.8 36.8369C113.2 34.3026 121.6 34.3026 130 36.8369C144.143 42.8369 152.543 42.8369 155.2 36.8369C163.6 30.8369 172 30.8369 180.4 36.8369C186.449 39.4781 194.849 39.4781 205.6 36.8369C214 34.1957 221.6 34.1957 230 36.8369"
        stroke="#ADB5BD"
      />
      <path
        d="M44.0009 23.8372C48.607 29.7675 46.8958 33.8914 40.5291 37.8726C34.6707 41.725 33.7905 46.6807 37.8884 52.7399C42.024 58.5866 41.1438 63.5424 35.2476 67.6072C33.4073 70.4924 32.527 75.4482 32.6069 82.4745C33.0139 87.659 32.1336 92.6147 29.9661 97.3418C24.2009 106.754 23.3206 111.709 27.3254 112.209C30.4134 117.87 29.5332 122.825 24.6846 127.076C22.775 130.145 21.8948 135.101 22.0439 141.944C22.4864 147.134 21.6061 152.09 19.4031 156.811C16.5257 162.39 15.8831 167.505 17 171.837"
        stroke="#ADB5BD"
      />
      <path
        d="M55.5007 23.8374C60.2642 29.6419 59.1867 33.4653 52.9292 37.6159C47.1762 41.624 46.4292 46.6015 50.6882 52.5486C54.9791 58.2823 54.2321 63.2599 48.4472 67.4815C46.6849 70.4149 45.9379 75.3925 46.2062 82.4142C46.7521 87.5859 46.0051 92.5635 43.9652 97.347C38.4545 106.91 37.7075 111.888 41.7242 112.28C44.963 117.856 44.216 122.833 39.4832 127.213C37.6566 130.332 36.9096 135.309 37.2422 142.145C37.8238 147.322 37.0768 152.3 35.0012 157.078C32.2745 162.732 31.2676 167.536 32.5004 171.837"
        stroke="#ADB5BD"
      />
      <path
        d="M70.0005 23.8375C74.759 29.6463 73.2431 33.4783 66.9819 37.6235C61.2255 41.6265 60.4741 46.6034 64.7278 52.5542C69.0138 58.2917 68.2624 63.2686 62.4737 67.4851C60.7088 70.417 59.9575 75.394 60.2196 82.4159C60.761 87.588 60.0096 92.5649 57.9655 97.3467C52.4464 106.905 51.695 111.882 55.7113 112.277C58.9452 117.856 58.1939 122.833 53.4572 127.208C51.6279 130.326 50.8765 135.303 51.2031 142.139C51.7802 147.317 51.0288 152.294 48.949 157.07C46.2173 162.722 45.4659 167.698 46.6949 172.001"
        stroke="#ADB5BD"
      />
      <path
        d="M83.0006 23.8376C87.8722 29.5518 85.9848 33.1942 79.8062 37.4615C74.1295 41.5768 73.476 46.5675 77.8458 52.4337C82.2436 58.0858 81.5901 63.0765 75.8854 67.4059C74.1785 70.3719 73.525 75.3626 73.925 82.3781C74.5679 87.5385 73.9144 92.5293 71.9646 97.3503C66.6343 107.015 65.9808 112.006 70.0042 112.322C73.347 117.836 72.6935 122.827 68.0438 127.295C66.276 130.447 65.6225 135.438 66.0833 142.267C66.762 147.432 66.1085 152.423 64.1229 157.239C61.5028 162.943 60.6871 167.56 62.0003 171.837"
        stroke="#ADB5BD"
      />
      <path
        d="M95.5006 23.8368C100.536 29.4073 98.7444 32.8188 92.6921 37.2635C87.1371 41.5417 86.6286 46.5493 91.1666 52.2862C95.7265 57.8085 95.218 62.816 89.6412 67.309C88.0209 70.3232 87.5124 75.3308 88.1157 82.3317C88.9079 87.4714 88.3994 92.479 86.5902 97.3545C81.5423 107.17 81.0339 112.177 85.0647 112.377C88.566 117.792 88.0575 122.8 83.5392 127.4C81.8636 130.603 81.3551 135.61 82.0137 142.423C82.8418 147.566 82.3333 152.574 80.4883 157.445C78.0346 163.223 77.5633 167.6 79 171.837"
        stroke="#ADB5BD"
      />
      <path
        d="M107.5 23.8371C112.698 29.2564 110.458 32.0507 104.54 36.6722C99.1136 41.1126 98.7533 46.133 103.459 51.7334C108.18 57.1185 107.82 62.139 102.378 66.7947C100.847 69.8555 100.487 74.876 101.297 81.856C102.241 86.97 101.88 91.9904 100.216 96.9172C95.4604 106.877 95.1001 111.898 99.1351 111.978C102.795 117.287 102.435 122.308 98.0541 127.04C96.4739 130.291 96.1136 135.311 96.9732 142.101C97.9529 147.218 97.5926 152.238 95.8923 157.162C93.6104 163.01 93.4389 167.644 95.0001 171.837"
        stroke="#ADB5BD"
      />
      <path
        d="M120 23.837C125.401 29.0536 122.096 30.7115 116.358 35.5559C111.106 40.2005 110.938 45.231 115.854 50.6474C120.777 55.8481 120.609 60.8787 115.35 65.739C113.937 68.8561 113.769 73.8866 114.845 80.8306C115.984 85.9048 115.816 90.9353 114.341 95.9222C109.969 106.057 109.801 111.087 113.836 111.014C117.696 116.179 117.528 121.209 113.332 126.105C111.877 129.414 111.709 134.445 112.827 141.197C114.002 146.272 113.834 151.303 112.323 156.288C110.266 162.219 110.28 167.707 112 171.837"
        stroke="#ADB5BD"
      />
      <path
        d="M131 23.8374C136.674 28.7565 132.997 29.3517 127.528 34.4972C122.533 39.4171 122.635 44.4494 127.835 49.594C133.03 54.5229 133.132 59.5552 128.141 64.6909C126.898 67.8794 127.001 72.9117 128.448 79.7878C129.857 84.7936 129.959 89.8259 128.755 94.8847C124.934 105.239 125.036 110.272 129.061 109.982C133.193 114.932 133.295 119.964 129.368 125.078C128.093 128.461 128.195 133.493 129.674 140.175C131.12 145.18 131.222 150.213 129.981 155.272C128.246 161.305 129.061 167.805 131 171.837"
        stroke="#ADB5BD"
      />
      <path
        d="M149 171.837C146.897 167.888 146.652 162.336 148.138 156.238C149.171 151.132 148.863 146.108 147.213 141.166C145.461 134.55 145.153 129.526 146.288 126.094C150.003 120.824 149.695 115.8 145.363 111.023C141.353 111.478 141.045 106.454 144.438 95.9512C145.435 90.8472 145.127 85.8233 143.514 80.8795C141.786 74.0685 141.477 69.0446 142.589 65.8079C147.365 60.472 147.057 55.4481 141.664 50.7362C136.257 45.809 135.949 40.7851 140.739 35.6646C144.799 31.5182 145.537 27.5756 142.953 23.837"
        stroke="#ADB5BD"
      />
      <path
        d="M165 171.837C162.799 167.942 162.187 162.226 163.521 156.092C164.425 150.961 163.991 145.947 162.219 141.048C160.302 134.478 159.868 129.463 160.918 126.004C164.499 120.642 164.065 115.628 159.616 110.96C155.619 111.515 155.185 106.501 158.315 95.9167C159.183 90.7894 158.75 85.7748 157.013 80.8729C155.116 74.1071 154.682 69.0925 155.712 65.829C160.353 60.3754 159.919 55.3608 154.41 50.7852C148.882 45.9947 148.448 40.9801 153.109 35.7414C157.029 31.5323 157.692 27.6049 155.097 23.9594"
        stroke="#ADB5BD"
      />
      <path
        d="M182 171.837C179.695 168.002 178.957 162.009 180.126 155.841C180.893 150.689 180.325 145.687 178.423 140.838C176.331 134.321 175.763 129.32 176.719 125.834C180.156 120.378 179.589 115.377 175.016 110.831C171.035 111.492 170.467 106.491 173.313 95.8269C174.044 90.6782 173.476 85.677 171.61 80.8233C169.532 74.1107 168.964 69.1095 169.906 65.8196C174.4 60.2438 173.833 55.2426 168.203 50.816C162.549 46.175 161.981 41.1738 166.5 35.8124C170.357 31.4419 170.878 27.4502 168.062 23.8373"
        stroke="#ADB5BD"
      />
      <path
        d="M198 171.837C195.625 168.045 194.553 161.799 195.608 155.611C196.28 150.445 195.62 145.455 193.628 140.642C191.416 134.165 190.756 129.175 191.648 125.672C194.983 120.154 194.323 115.164 189.668 110.702C185.699 111.437 185.039 106.448 187.688 95.7328C188.324 90.5715 187.664 85.5816 185.708 80.7632C183.506 74.0901 182.846 69.1003 183.727 65.7936C188.118 60.1357 187.458 55.1458 181.747 50.824C176.009 46.2882 175.349 41.2983 179.767 35.8544C183.549 31.4068 183.992 27.4009 181.095 23.8367"
        stroke="#ADB5BD"
      />
      <path
        d="M213 171.837C210.564 168.084 209.811 162.578 210.766 156.374C211.355 151.197 210.615 146.219 208.546 141.438C206.23 134.997 205.489 130.019 206.325 126.502C209.571 120.931 208.831 115.952 204.104 111.566C200.148 112.365 199.408 107.386 201.883 96.6303C202.436 91.4595 201.696 86.4809 199.662 81.6946C197.354 75.0578 196.613 70.0792 197.441 66.7588C201.74 61.0309 201 56.0523 195.221 51.823C189.41 47.3802 188.669 42.4016 193 36.8872C197.13 31.8678 197.13 27.4626 193 23.6716"
        stroke="#ADB5BD"
      />
      <path
        d="M205.999 23.8361C212.251 27.9951 211.771 32.0892 207 37.8873C202.669 43.4017 203.409 48.3803 209.221 52.8231C215 57.0524 215.74 62.031 211.441 67.7589C210.613 71.0793 211.354 76.0579 213.662 82.6947C215.696 87.481 216.436 92.4596 215.883 97.6305C213.408 108.386 214.148 113.365 218.104 112.566C222.831 116.952 223.571 121.931 220.325 127.502C219.489 131.019 220.23 135.997 222.546 142.438C224.615 147.219 225.355 152.197 224.766 157.374C223.811 163.578 224.564 168.084 227 171.837"
        stroke="#ADB5BD"
      />
      <path
        d="M217 23.8361C223.343 27.8549 224.314 33.2008 219.673 39.1038C215.467 44.7132 216.318 49.6741 222.226 53.9864C228.098 58.086 228.949 63.0469 224.779 68.8691C224.025 72.2071 224.876 77.168 227.332 83.7517C229.471 88.4915 230.322 93.4524 229.885 98.6343C227.649 109.443 228.5 114.404 232.438 113.517C237.261 117.796 238.112 122.757 234.99 128.4C234.234 131.934 235.085 136.895 237.543 143.282C239.718 148.016 240.569 152.977 240.096 158.165C239.279 164.389 240.481 168.138 243 171.836"
        stroke="#ADB5BD"
      />
      <path
        d="M58.6364 57C58.6364 57 58.8701 55.1299 57 53.026C57 53.026 59.3377 52.7922 60.7403 55.3636C60.7403 55.3636 61.4416 49.987 59.3377 46.2468C59.3377 46.2468 63.0779 46.9481 64.4805 55.1299C64.4805 55.1299 65.4156 45.0779 62.6104 39C62.6104 39 68.9221 43.2078 68.6883 53.7273C68.6883 53.7273 70.0909 48.8182 73.1299 48.1169C73.1299 48.1169 71.2597 51.1558 71.2597 55.1299C71.2597 55.1299 72.4286 53.4935 75 52.7922C75 52.7922 74.0649 53.7273 74.0649 55.3636C74.0649 57 74.0649 57 74.0649 57"
        fill="url(#paint0_linear_687_6885)"
      />
      <path
        d="M212.636 135C212.636 135 212.87 133.13 211 131.026C211 131.026 213.338 130.792 214.74 133.364C214.74 133.364 215.442 127.987 213.338 124.247C213.338 124.247 217.078 124.948 218.481 133.13C218.481 133.13 219.416 123.078 216.61 117C216.61 117 222.922 121.208 222.688 131.727C222.688 131.727 224.091 126.818 227.13 126.117C227.13 126.117 225.26 129.156 225.26 133.13C225.26 133.13 226.429 131.494 229 130.792C229 130.792 228.065 131.727 228.065 133.364C228.065 135 228.065 135 228.065 135"
        fill="url(#paint1_linear_687_6885)"
      />
      <path
        d="M123.364 91C123.364 91 123.13 89.1299 125 87.026C125 87.026 122.662 86.7922 121.26 89.3636C121.26 89.3636 120.558 83.987 122.662 80.2468C122.662 80.2468 118.922 80.9481 117.519 89.1299C117.519 89.1299 116.584 79.0779 119.39 73C119.39 73 113.078 77.2078 113.312 87.7273C113.312 87.7273 111.909 82.8182 108.87 82.1169C108.87 82.1169 110.74 85.1558 110.74 89.1299C110.74 89.1299 109.571 87.4935 107 86.7922C107 86.7922 107.935 87.7273 107.935 89.3636C107.935 91 107.935 91 107.935 91"
        fill="url(#paint2_linear_687_6885)"
      />
      <path
        d="M75.3636 134C75.3636 134 75.1299 132.13 77 130.026C77 130.026 74.6623 129.792 73.2597 132.364C73.2597 132.364 72.5584 126.987 74.6623 123.247C74.6623 123.247 70.9221 123.948 69.5195 132.13C69.5195 132.13 68.5844 122.078 71.3896 116C71.3896 116 65.0779 120.208 65.3117 130.727C65.3117 130.727 63.9091 125.818 60.8701 125.117C60.8701 125.117 62.7403 128.156 62.7403 132.13C62.7403 132.13 61.5714 130.494 59 129.792C59 129.792 59.9351 130.727 59.9351 132.364C59.9351 134 59.9351 134 59.9351 134"
        fill="url(#paint3_linear_687_6885)"
      />
      <path
        d="M120.364 157C120.364 157 120.13 155.13 122 153.026C122 153.026 119.662 152.792 118.26 155.364C118.26 155.364 117.558 149.987 119.662 146.247C119.662 146.247 115.922 146.948 114.519 155.13C114.519 155.13 113.584 145.078 116.39 139C116.39 139 110.078 143.208 110.312 153.727C110.312 153.727 108.909 148.818 105.87 148.117C105.87 148.117 107.74 151.156 107.74 155.13C107.74 155.13 106.571 153.494 104 152.792C104 152.792 104.935 153.727 104.935 155.364C104.935 157 104.935 157 104.935 157"
        fill="url(#paint4_linear_687_6885)"
      />
      <path
        d="M161.5 6L174.5 7.5L189 11.5L204 15.5L211 18.5L216.5 25.5L202 88L192.5 124L187.5 142.5L180 149.5L168.5 149L154 145.5L136 140.5L127 133.5V124L129.5 115L156 15.5L161.5 6Z"
        fill="url(#paint5_linear_687_6885)"
      />
      <path
        d="M155.094 16.1636C157.097 8.62754 164.871 4.18042 172.382 6.27377L206.483 15.7773C213.833 17.8256 218.189 25.3815 216.279 32.7682L188.562 139.956C186.614 147.491 178.894 151.991 171.377 149.972L136.468 140.596C129.014 138.594 124.587 130.937 126.569 123.478L155.094 16.1636Z"
        stroke="black"
        strokeOpacity="0.85"
        strokeWidth="4"
      />
      <rect
        width="1.9921"
        height="14.915"
        rx="0.99605"
        transform="matrix(0.96919 0.246314 -0.244597 0.969625 214.181 45.7285)"
        fill="black"
      />
      <rect
        width="1.9921"
        height="14.915"
        rx="0.99605"
        transform="matrix(0.96919 0.246314 -0.244597 0.969625 145.438 39.7695)"
        fill="black"
      />
      <rect
        width="1.9921"
        height="14.915"
        rx="0.99605"
        transform="matrix(0.96919 0.246314 -0.244597 0.969625 149.422 23.8613)"
        fill="black"
      />
      <ellipse
        cx="168.85"
        cy="31.3177"
        rx="4.48276"
        ry="4.47399"
        fill="#06D6A0"
      />
      <ellipse
        cx="193.483"
        cy="48.474"
        rx="4.48276"
        ry="4.47399"
        fill="#06D6A0"
      />
      <ellipse
        cx="158.483"
        cy="58.474"
        rx="4.48276"
        ry="4.47399"
        fill="#06D6A0"
      />
      <ellipse
        cx="162.483"
        cy="76.474"
        rx="4.48276"
        ry="4.47399"
        fill="#06D6A0"
      />
      <ellipse
        cx="173.831"
        cy="98.9252"
        rx="4.48276"
        ry="4.47399"
        fill="#06D6A0"
      />
      <ellipse
        cx="153.908"
        cy="125.769"
        rx="4.48276"
        ry="4.47399"
        fill="#06D6A0"
      />
      <defs>
        <linearGradient
          id="paint0_linear_687_6885"
          x1="66"
          y1="39"
          x2="66"
          y2="57"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.46875" stopColor="#073B4C" />
          <stop offset="1" stopColor="#073B4C" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_687_6885"
          x1="220"
          y1="117"
          x2="220"
          y2="135"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.46875" stopColor="#073B4C" />
          <stop offset="1" stopColor="#073B4C" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_687_6885"
          x1="116"
          y1="73"
          x2="116"
          y2="91"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.46875" stopColor="#073B4C" />
          <stop offset="1" stopColor="#073B4C" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_687_6885"
          x1="68"
          y1="116"
          x2="68"
          y2="134"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.46875" stopColor="#073B4C" />
          <stop offset="1" stopColor="#073B4C" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_687_6885"
          x1="113"
          y1="139"
          x2="113"
          y2="157"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.46875" stopColor="#073B4C" />
          <stop offset="1" stopColor="#073B4C" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_687_6885"
          x1="215.844"
          y1="20.2132"
          x2="128.233"
          y2="134.931"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4E4E4" stopOpacity="0.8" />
          <stop offset="1" stopColor="#F1F1F1" stopOpacity="0.1" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ArStep3_1;
